import { useContext } from 'react';

const useRouteContext = ctx => useContext(ctx) || {};

export default useRouteContext;
